<template>
  <div>
    <form-item :label="$t('CampaignForm_Schedule_Repeat_Custom_Schedule')">
      <div class="container">
        <span class="label">
          {{ $t('CampaignForm_Schedule_Repeat_RepeatEvery') }}
        </span>
        <el-input-number
          :controls="false"
          v-model="model.send_frequency"
          :min="1"
        />
        <span class="interval-selector">
          <el-select
            v-model="model.send_interval"
            :placeholder="$t('CampaignForm_Schedule_Repeat_PlaceholderSelect')"
          >
            <el-option
              v-for="(intervalValue, intervalKey) in sendIntervalLabels"
              :key="intervalKey"
              :label="$t(intervalValue)"
              :value="intervalKey"
            />
          </el-select>
        </span>
      </div>
    </form-item>
    <form-item :label="$t('CampaignForm_Schedule_Repeat_RepeatOn')">
      <div
        class="container send-option-ct"
        v-if="model.send_interval === 'months'"
      >
        <span>
          <el-select
            v-model="model.send_option"
            :placeholder="$t('CampaignForm_Schedule_Repeat_PlaceholderSelect')"
            style="width: 250px"
          >
            <el-option
              v-for="(optionValue, optionKey) in monthSendOptionLabels"
              :key="optionKey"
              :label="$t(optionValue)"
              :value="optionKey"
            />
          </el-select>
        </span>
      </div>
      <div>
        <custom-schedule-day-button-checkbox
          :options="daysofWeekLabels"
          :model="model"
        />
      </div>
    </form-item>
  </div>
</template>

<script>
import FormItem from '@/common/components/form/FormItem'
import {
  sendIntervalLabels,
  monthSendOptionLabels,
  daysofWeekLabels
} from './enum/CustomScheduleEnum'
import CustomScheduleDayButtonCheckbox from './CustomScheduleDayButtonCheckbox.vue'

export default {
  name: 'CustomScheduleComponent',
  components: { CustomScheduleDayButtonCheckbox, FormItem },
  props: {
    model: {
      type: Object,
      required: true
    }
  },
  mounted() {
    if (this.model.send_interval === null) {
      this.model.send_interval = 'weeks'
    }
  },
  data() {
    return {
      sendIntervalLabels,
      monthSendOptionLabels,
      daysofWeekLabels
    }
  }
}
</script>

<style scoped>
.container {
  display: flex;
}
.send-option-ct {
  margin-bottom: 20px;
}
.label {
  align-self: center;
}
.el-input-number {
  width: 50px;
}
.interval-selector {
  width: 120px;
}
span {
  color: #7e8596;
  font-size: 14px;
  line-height: 22px;
}
</style>



// WEBPACK FOOTER //
// src/modules/campaign-manage/components/schedule/CustomScheduleComponent.vue